import React from "react";
import { useTranslation } from "react-i18next";

function LegalPage({ tKey }) {
  const { t } = useTranslation();
  const sections = t(`${tKey}.sections`, { returnObjects: true }) || {};
  return (
    <div className="ec-legal">
      <div className="ec-container ec-legal-inner">
        <span className="ec-eyebrow">Ecominiere</span>
        <h1 className="ec-h1 ec-h1--legal">{t(`${tKey}.title`)}</h1>
        <p className="ec-legal-updated">{t(`${tKey}.updated`)}</p>
        <p className="ec-para">{t(`${tKey}.intro`)}</p>
        <div className="ec-legal-sections">
          {Object.keys(sections).map((k) => (
            <section key={k} className="ec-legal-sec">
              <h2>{sections[k].title}</h2>
              <p>{sections[k].body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Privacy() { return <LegalPage tKey="privacy" />; }
export function Cookies() { return <LegalPage tKey="cookies" />; }
export function Terms() { return <LegalPage tKey="terms" />; }
